import { api } from './api-client';
import { UserRole } from '@/lib/auth';

export interface User {
  userId: string;
  email: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
}

export interface Reseller {
  resellerId: string;
  name: string;
  contactDetails: string;
  distributorUserId: string;
  createdAt: string;
  updatedAt: string;
}

export interface Customer {
  customerId: string;
  name: string;
  contactDetails: string;
  resellerId: string | null;
  distributorDirect: boolean;
  createdAt: string;
  updatedAt: string;
}

export const usersApi = {
  // Users
  getCurrentUser: () => 
    api.get<User>('/users/me'),
  
  // Resellers
  getResellers: () => 
    api.get<Reseller[]>('/resellers'),
  
  getReseller: (resellerId: string) => 
    api.get<Reseller>(`/resellers/${resellerId}`),
  
  createReseller: (data: { name: string, contactDetails: string, distributorUserId: string }) => 
    api.post<Reseller>('/resellers', data),
  
  updateReseller: (resellerId: string, data: { name?: string, contactDetails?: string }) => 
    api.put<Reseller>(`/resellers/${resellerId}`, data),
  
  // Customers
  getCustomers: (resellerId?: string) => 
    api.get<Customer[]>(`/customers${resellerId ? `?reseller_id=${resellerId}` : ''}`),
  
  getCustomer: (customerId: string) => 
    api.get<Customer>(`/customers/${customerId}`),
  
  createCustomer: (data: { 
    name: string, 
    contactDetails: string, 
    resellerId?: string | null, 
    distributorDirect: boolean 
  }) => 
    api.post<Customer>('/customers', data),
  
  updateCustomer: (customerId: string, data: { 
    name?: string, 
    contactDetails?: string,
    resellerId?: string | null
  }) => 
    api.put<Customer>(`/customers/${customerId}`, data),
};
